var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTpNotFulfilledIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TP-not-fulfilled-indicator",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.567,
    height: 44.566,
    viewBox: "0 0 44.567 44.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_21",
    "data-name": "Vereinigungsmenge 21",
    d: "M12447,22133.848a22.284,22.284,0,1,1,22.281,22.285A22.281,22.281,0,0,1,12447,22133.848Zm14-19.607a21.342,21.342,0,1,0,8.285-1.674A21.116,21.116,0,0,0,12461,22114.24Zm1.769,26.129a.841.841,0,0,1-.256-.611.854.854,0,0,1,.256-.617l5.287-5.293-5.287-5.289a.869.869,0,0,1,1.229-1.229l5.288,5.293,5.288-5.293a.871.871,0,1,1,1.234,1.229l-5.294,5.289,5.294,5.293a.88.88,0,0,1,0,1.229.887.887,0,0,1-1.234,0l-5.288-5.293-5.288,5.293a.87.87,0,0,1-.617.256A.845.845,0,0,1,12462.766,22140.369Z",
    transform: "translate(-12447.001 -22111.566)",
    fill: "#ea4967"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpNotFulfilledIndicator);
export default __webpack_public_path__ + "static/media/tpNotFulfilledIndicator.9cde510d77824ecaff1ca190b8dcc9bf.svg";
export { ForwardRef as ReactComponent };